var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "payment-method",
        {
          "payment-method_selected": _vm.info.selected,
          "payment-method_disabled": _vm.disabled
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "payment-method__icon" },
        [_c("payment-icons", { attrs: { icon: _vm.icon } })],
        1
      ),
      _c("div", { staticClass: "payment-method__text" }, [
        _vm._v("\n    " + _vm._s(_vm.title) + "\n  ")
      ]),
      _vm.info.selected
        ? _c(
            "div",
            { staticClass: "payment-method__selected-icon" },
            [
              _c("f-sprite-icon", {
                attrs: { "icon-link": _vm.$options.icons.IconCheck.id }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }